module.exports = __webpack_public_path__ + "img/Zugtrupp.6b2c2af6.svg";